import { EXP_CATEGORY_LUX_PLUS_ID, EXP_CATEGORY_LUX_PLUS_MEMBER_PRICES_ID } from 'constants/experience'

export const LUX_PLUS_MEMBER_PRICES_FILTER = 'Member prices' as App.LuxPlusFeatureFilter

const LUX_PLUS_CATEGORY_IDS = [EXP_CATEGORY_LUX_PLUS_ID, EXP_CATEGORY_LUX_PLUS_MEMBER_PRICES_ID]

export function hasLuxPlusCategoryFilter(categoryCodes?: Array<number>) {
  return !!categoryCodes?.some((code) => LUX_PLUS_CATEGORY_IDS.includes(code))
}

export function removeLuxPlusCategoryFilters(categoryCodes?: Array<number>) {
  return categoryCodes?.filter((code) => !LUX_PLUS_CATEGORY_IDS.includes(code))
}

export function withLegacyLuxPlusCategoryFilter(
  luxPlusFeatures?: Array<App.LuxPlusFeatureFilter>,
  categoryCodes?: Array<number>,
) {
  if (!hasLuxPlusCategoryFilter(categoryCodes)) {
    return luxPlusFeatures
  }

  if (luxPlusFeatures?.includes(LUX_PLUS_MEMBER_PRICES_FILTER)) {
    return luxPlusFeatures
  }

  return [...(luxPlusFeatures ?? []), LUX_PLUS_MEMBER_PRICES_FILTER]
}
